module.exports = __webpack_public_path__ + "05-frigorifero.jpg?33e31bf38435f5388201535679935e4f";


//////////////////
// WEBPACK FOOTER
// ./src/img/gioco2/05-frigorifero.jpg
// module id = 386
// module chunks = 0